import type { InferOutput } from "valibot"
import { array, nullish, number, object, string } from "valibot"

export const getNextPrevPageResponseSchema = object({ chapter: nullish(string()), page: string() })
export type GetNextPrevPageResponse = InferOutput<typeof getNextPrevPageResponseSchema>

export const autocompleteItemSchema = object({ name: string(), value: string(), category: nullish(string()) })
export type AutocompleteItem = InferOutput<typeof autocompleteItemSchema>

export const getQuestionnaireResponseSchema = object({
  id: number(),
  key: string(),
  chapters: array(object({ id: number(), key: string(), phase: string() })),
})
export type GetQuestionnaireResponse = InferOutput<typeof getQuestionnaireResponseSchema>

export const getQuestionnaireProgressSchema = object({
  chapter: string(),
  progress: number(),
})
export type GetQuestionnaireProgress = InferOutput<typeof getQuestionnaireProgressSchema>

export const sendAnswersResponseSchema = object({
  chapter: nullish(string()),
  page: string(),
  error: nullish(string()),
})
export type sendAnswersResponse = InferOutput<typeof sendAnswersResponseSchema>

export const getCurrentQuestionnairePageResponseSchema = object({
  chapter: string(),
  page: string(),
})
export type GetCurrentQuestionnairePageResponse = InferOutput<
  typeof getCurrentQuestionnairePageResponseSchema
>
